export const GET_ALL_MESSAGES_SUCCESS =
  'netwila/messages/all-GET_ALL_MESSAGES_SUCCESS';
export const GET_ALL_MESSAGES_ERROR =
  'netwila/messages/all-GET_ALL_MESSAGES_ERROR';
export const TOGGLE_LOADING = 'netwila/messages/all-TOGGLE_LOADING';
export const FILTER_MESSAGES = 'netwila/messages/all-FILTER_MESSAGES';
export const SET_SELECTED_CONTACT = 'netwila/messages/all-SET_SELECTED_CONTACT';
